module.exports = __webpack_public_path__ + "img/podiumcadeaukaart.ec6db51e.svg";